export enum CatalogueAttributeType {
	Form = "FORM",
	Patient = "PATIENT",
	Record = "RECORD",
}
